/* =================== ENVIA CONTATO =================== */
jQuery(document).ready(function ($) {
  var enviando_formulario = false;
  $('#form-contato').on('submit', function (e) {
    e.preventDefault();

    const $inputRetorno = $(this).find('input[name="retorno"]');
    let retornoUrl = null;
    if ($inputRetorno.length > 0) {
      retornoUrl = $inputRetorno.val();
    }

    var obj = this;
    var form = $(obj);
    var submit_btn = form.find('#enviar');
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr('disabled', false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr('disabled', true);
          submit_btn.text('Enviando...');
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          if (data == 'ok') {
            $('#form-contato .campo').val('');
            if (retornoUrl) {
              window.location.href = `${retornoUrl}`;
              return;
            } else if (page == 'agendamento-filas-expressas') {
              showAlert(
                'Sua solicitação foi enviada com sucesso',
                'Em breve entraremos em contato para prosseguirmos com o atendimento.',
                'success',
              );
              setTimeout(() => {
                location.reload();
              }, 4500);
            } else if (page == 'contrato-prestacao-de-servicos') {
              showAlert(
                'Sucesso',
                'Sua confirmação de contrato foi enviada com sucesso.',
                'success',
              );
              setTimeout(() => {
                location.reload();
              }, 4500);
            } else {
              showAlert(
                'Sucesso',
                'Sua mensagem foi enviada com sucesso.',
                'success',
              );
            }
          } else if (data == 'maximo_familhas') {
            showAlert(
              'Erro',
              'Serviço indisponível para famílias ou grupos maiores do que 08 pessoas.',
              'error',
            );
          } else if (data == 'hopper') {
            showAlert(
              'Erro',
              'Serviço indisponível para portadores de ingressos na modalidade Hopper.',
              'error',
            );
          } else {
            showAlert('Erro', 'Não foi possível enviar a mensagem.', 'error');
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert('Erro', 'Não foi possível enviar a mensagem.', 'error');
          console.log('ajax error response type ' + type);
        },
      });
    }
  });
});
